import React 		from 'react'
import classnames 	from 'classnames'
import renderHTML 	from 'react-render-html'

class TextBlock extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			align,
			type,
			children,
			subheading,
			className
		} = this.props

		return <div className={ classnames('textBlock', {
				[`textBlock--${ type }`]: !!type,
				[`textBlock--a-${ align }`]: !!align
			}, className) }>
			{ subheading ? <h2 className="p--subheading">{ renderHTML(subheading) }</h2> : null }
			{ children }
		</div>
	}
}

export default TextBlock